import { useState, useEffect, useRef } from "react";

function WhyUs() {
  return (
    <section className="whyAstrovala bg3 pt-50 pb-50">
      <div className="site-width">
        <div className="whyastroWrap">
          <div className="row col-reverse align-item-center ">
            <div className="col-md-5 wow animate__fadeInRight">
              <div className="imgSec whatisastroImg movenormal">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/other/about-img.png`}
                  alt="img"
                />
              </div>
            </div>
            <div className="col-md-7 wow animate__fadeInLeft">
              <div className="halfContent left">
                <div className="textWrapper light">
                  <h5>Why Us</h5>
                  <h2>What can I do with Hourlee?</h2>
                  <p>
                    At Hourlee, we’re redefining the way people work and hire. Our platform bridges the gap between businesses that need instant, reliable manpower and individuals seeking flexible and fair work opportunities. Designed for today’s fast-paced world, Hourlee combines technology, trust, and transparency to make hourly hiring and working effortless. Whether you’re an employer scaling up for peak hours or a professional looking for freedom and control, Hourlee helps you connect, collaborate, and grow — one hour at a time.
                  </p>
                  <div className="whychoosePoints mt-4">
                    <div className="whyFeatures mt-3">
                      <div className="whyfeatCard">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/img/icons/benefit-icon1.svg`}
                          alt="icon"
                        />
                        <h6>Smart & Instant Hiring</h6>
                      </div>
                      <div className="whyfeatCard">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/img/icons/benefit-icon2.svg`}
                          alt="icon"
                        />
                        <h6>Flexible Work, Fair Pay</h6>
                      </div>
                      <div className="whyfeatCard">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/img/icons/benefit-icon3.svg`}
                          alt="icon"
                        />
                        <h6>Secure & Transparent System</h6>
                      </div>
                      <div className="whyfeatCard">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/img/icons/benefit-icon4.svg`}
                          alt="icon"
                        />
                        <h6>Empowering the Future of Work</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
